module.exports = __webpack_public_path__ + "static/media/tomy_petirandi_w.411075a8.jpg";